import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteMeetingSummary } from "../../hooks/useManagement";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";

export const ShowMeetingModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);

  return (
    <BootstrapModal
      modaltitle="صورت جلسه"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-6 col-12">
          <InputField1
            readonly
            label="موضوع صورت جلسه"
            value={item?.SubjectMeeting}
          />
        </div>
        <div className="col-lg-6 col-12">
          <InputField1
            readonly
            value={item?.DateMeeting}
            label="تاریخ صورت جسه"
          />
        </div>
        <div className="col-12">
          <SimpleTextArea
            value={item?.DescriptionMeeting}
            readonly
            label="متن صورت جلسه"
            rows="5"
          />
        </div>

        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            بستن
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
